import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from '../_services/home.service';
import { HelpTopics } from '../_model/helptopics';
import { GuidedHelp } from '../_model/guidedhelp';
import { Footer, FooterContent } from '../_model/footer';
import { Title } from '@angular/platform-browser';
import { AuthenticationService } from '../_services/index';
import { GoogleAnalyticsService } from '../_services/google-analytics.service';

@Component({
  selector: 'app-help-topics',
  templateUrl: './help-topics.component.html',
  styleUrls: ['./help-topics.component.scss']
})
export class HelpTopicsComponent implements OnInit {
  pk: number;
  topics: HelpTopics;
  contact: Footer = {};
  contactDetails: FooterContent = {};
  helpTopics: GuidedHelp = {};
  status: boolean;
  name: String;
  names: any;
  topArticles: any;
  article: any;
  parentPk: any;
  topArticleTitle: any;
  searchdata: any[];
  selectedValue: any;
  keyword = 'name';
  data = [];
  caseAlertMessage: string;
  alert: boolean = false;
  delayed: boolean = false;
  searchBanner: any;
  searchTextboxNote: any;
  searchTextboxHover: any;
  searchButtonHover: any;
  searchKey: any;

  constructor(private activatedRoute: ActivatedRoute,
              private homeService: HomeService,
              private authenticationService: AuthenticationService,
              private router: Router,
              private gaService : GoogleAnalyticsService) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.pk = params['PK'];
      this.getChildren();
      });
   }
   
  ngOnInit() {
    this.gaService.updatePageName();
    this.kbSearchConfig();
   this.getTopArticles();
   this.getTopArticleTitle();
   this.caseMessage();
  }

  kbSearchConfig(){
    this.homeService.getKbSearchConfiguration().subscribe(res => {
      this.searchBanner = res.return_body.searchBanner;
      this.searchTextboxNote = res.return_body.searchTextboxNote;
      this.searchTextboxHover = res.return_body.searchTextboxHoverNote;
      this.searchButtonHover = res.return_body.searchButtonHoverNote;
    });
  }

  getChildren() {
    this.homeService.getChildren(this.pk).subscribe(res => {
      this.topics = res;
      this.names= res.return_body;
      this.getHelpTopics();
      for(var val of this.names){
        if(val.parentPk==this.pk){
         this.parentPk= val.parentPk
        }
      }
    });
  }
  getHelpTopics() {
    this.status=true;
    this.homeService.getHelpTopics().subscribe(res => {
    this.names= res.return_body;
    this.helpTopics = res;
    this.names=res.return_body
      for(var val of this.names){
        if(val.pk==this.pk){
         this.name= val.stepName
        }
      }
    });
  }
  getAllArticle(pk) {
    this.router.navigate(['/' + this.router.url.split('/')[1] + '/search'], { queryParams: { PK: pk,parentPk:this.parentPk }});
  }

  handleNavigation(pathValue) {
    if(pathValue){
        this.router.navigate([this.router.url.split("/")[1],pathValue]);  
    }
}
  getTopArticles() {    
    this.homeService.getTopArticles().subscribe(res => {
    this.topArticles = res.return_body;
  });
}
getTopArticleTitle() {
  this.homeService.getTopArticleTitle().subscribe(res =>{
    this.topArticleTitle = res.return_body.title;
  })
}
selectEvent(item) {
  this.selectedValue = item.name;
  this.search(this.selectedValue);
}

onChangeSearch(val: string) {
  this.selectedValue = val;
  this.data = [];
  if (val != '') {
    this.homeService.getSearchData(val).subscribe(res => {
      this.data = [];
      res.return_body.map((response, index) => {
        this.data.push({ id: index, name: response });
      })
    });
  }
}

onFocused(e) {
  this.data = [];
}

search(selectedValue){
  this.router.navigate(['/' + this.router.url.split('/')[1] + '/searchresults'], { queryParams: { selectedValue: selectedValue, currentPage: 0 }});
}
onKeyEnterSearch(event: any, searchkeyWrd: any) {
  this.search(searchkeyWrd);
}

searchCleared(){
  this.selectedValue = '';
}

 caseMessage() {
  this.caseAlertMessage = sessionStorage.getItem('alertMessage')
  if (this.caseAlertMessage) {
    this.alert = true
  }
  setInterval(() => {
    this.delayed = true
    this.alert = false
    sessionStorage.removeItem('alertMessage')
  }, 5000);
}  

}
